import "./headingComponent.scss";

import React, {JSXElementConstructor, ReactElement, useCallback} from 'react';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ChipComponent from "../chip/ChipComponent";
import {CommonService} from "../../services";

interface HeadingComponentProps {
    title: string;
    onBackNavigation?: Function;
    statusLabel?: string;
    statusIcon?: ReactElement<any, string | JSXElementConstructor<any>> | undefined;
    backText?: string;
}

const HeadingComponent = (props: HeadingComponentProps) => {

    const {title, onBackNavigation, backText,statusIcon,statusLabel} = props;

    const handleBackClick = useCallback(() => {
        if (onBackNavigation) {
            onBackNavigation();
        }
    }, [onBackNavigation]);

    return (
        <>
            <div className="heading-wrapper">
                {
                    onBackNavigation &&
                    <div className="back-navigation-wrapper" onClick={handleBackClick}>
                        <ArrowBackIosIcon className="navigate-back-icon"/>
                        <div className="navigate-back-text">{backText}</div>
                    </div>

                }
                <div className="heading-title-with-navigation">
                    <div className= {'heading-title'}>
                        {CommonService.capitalizeFirstLetter(title)}
                    </div>
                    {statusLabel && <div className={'heading-status'}>
                        <ChipComponent
                            label={CommonService.capitalizeFirstLetter(statusLabel)}
                            icon={statusIcon}
                            className={statusLabel}
                        variant={"outlined"}/>
                    </div>}
                </div>
            </div>
        </>
    );
};
export default HeadingComponent;